import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

interface DynamicDataItem {
  name: string;
  content: string;
}

@Component({
  selector: 'app-dynamic-data-modal',
  template: `
    <div class="modal-header border-0 py-3">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-center">
          <i class="fas fa-info-circle text-primary me-2"></i>
          <h5 class="modal-title mb-0">Dynamic Data</h5>
        </div>
        <span class="text-muted mt-1 small">{{ email }}</span>
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
    </div>
    <div class="modal-body p-4">
      <!-- Debug info -->
      <div class="mb-3" style="background: #f8f9fa; padding: 10px; border-radius: 5px;">
        <small class="text-muted">
          Debug: Data array length: {{ data?.length || 0 }} | 
          Data type: {{ getDataType() }} |
          Has data: {{ hasData() }}
        </small>
      </div>
      
      <div class="table-responsive" *ngIf="hasData()">
        <table class="table table-hover mb-0">
          <thead>
            <tr>
              <th style="width: 30%">Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of data; let i = index">
              <td class="fw-semibold">{{ item.name || 'Field ' + (i + 1) }}</td>
              <td>
                <span *ngIf="!isUrl(item.content)" [innerHTML]="item.content || 'N/A'"></span>
                <a *ngIf="isUrl(item.content)" 
                   [href]="item.content" 
                   target="_blank" 
                   class="text-primary text-decoration-none"
                   style="word-break: break-all;">
                  <i class="fas fa-external-link-alt me-1"></i>
                  {{ item.content }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="text-center py-4" *ngIf="!hasData()">
        <i class="fas fa-info-circle text-muted fa-2x mb-2"></i>
        <p class="text-muted mb-0">No dynamic data available</p>
      </div>
    </div>
  `,
  styles: [`
    .table th {
      font-weight: 600;
      color: #495057;
      font-size: 0.9rem;
      padding: 1rem;
      background-color: #f8f9fa;
      border-bottom: 1px solid #e9ecef;
    }

    .table td {
      padding: 1rem;
      vertical-align: middle;
      color: #495057;
      font-size: 0.9rem;
      border-bottom: 1px solid #f1f3f5;
    }

    .table tr:hover {
      background-color: #f8f9fa;
    }

    .table a:hover {
      text-decoration: underline !important;
    }

    .table a {
      font-size: 0.85rem;
    }
  `]
})
export class DynamicDataModalComponent implements OnInit {
  @Input() data: DynamicDataItem[] = [];
  @Input() email: string = '';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    console.log('DynamicDataModalComponent initialized');
    console.log('Received data:', this.data);
    console.log('Received email:', this.email);
    console.log('Data type:', typeof this.data);
    console.log('Data is array:', Array.isArray(this.data));
    console.log('Data length:', this.data?.length);
  }

  hasData(): boolean {
    return Array.isArray(this.data) && this.data.length > 0;
  }

  getDataType(): string {
    return typeof this.data;
  }

  /**
   * Check if the content is a URL
   */
  isUrl(content: string): boolean {
    if (!content || typeof content !== 'string') {
      return false;
    }
    
    // Check if it starts with http:// or https://
    const urlPattern = /^https?:\/\/.+/i;
    return urlPattern.test(content.trim());
  }
} 